import React from "react";
import Loginheader from "./loginheader/Loginheader";
import Footer from "./footer/Footer";

const styles = {
  wrapper: {
    maxWidth: 960,
    margin: "0 auto",
    padding: "40px 24px 80px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    background: "#ffffff",
    minHeight: "100vh",
  },
  hero: {
    background: "linear-gradient(135deg, #1a3a6e 0%, #1565c0 55%, #1976d2 100%)",
    borderRadius: 20,
    padding: "52px 48px",
    marginBottom: 40,
    boxShadow: "0 20px 60px rgba(21,101,192,0.35)",
    position: "relative",
    overflow: "hidden",
  },
  heroBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(255,255,255,0.15)",
    border: "1px solid rgba(255,255,255,0.25)",
    color: "#fff",
    padding: "5px 14px",
    borderRadius: 100,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.8px",
    textTransform: "uppercase",
    marginBottom: 20,
  },
  heroTitle: {
    fontSize: 34,
    fontWeight: 800,
    color: "#fff",
    lineHeight: 1.2,
    marginBottom: 12,
  },
  heroSub: {
    fontSize: 15,
    color: "rgba(255,255,255,0.78)",
    fontWeight: 400,
    maxWidth: 540,
    lineHeight: 1.7,
    marginBottom: 0,
  },
  heroDate: {
    position: "absolute",
    top: 28,
    right: 40,
    fontSize: 12,
    color: "rgba(255,255,255,0.6)",
    fontWeight: 500,
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 14,
    marginBottom: 40,
  },
  infoCard: {
    background: "#fff",
    borderRadius: 14,
    padding: "20px 18px",
    border: "1.5px solid #e8edf7",
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
  },
  cardIcon: (bg) => ({
    width: 40,
    height: 40,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    marginBottom: 12,
    background: bg,
  }),
  cardLabel: {
    fontSize: 10,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    color: "#90a4ae",
    marginBottom: 4,
  },
  cardValue: {
    fontSize: 13,
    fontWeight: 600,
    color: "#1a2a4a",
    lineHeight: 1.5,
    whiteSpace: "pre-line",
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "1.2px",
    color: "#1565c0",
    marginBottom: 16,
  },
  policyCard: {
    background: "#fff",
    borderRadius: 16,
    border: "1.5px solid #e8edf7",
    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
    padding: "36px 40px",
    marginBottom: 40,
  },
  sectionBlock: {
    marginBottom: 36,
    paddingBottom: 36,
    borderBottom: "1px solid #f0f4fb",
  },
  sectionBlockLast: {
    marginBottom: 0,
    paddingBottom: 0,
  },
  sectionTitle: {
    fontSize: 17,
    fontWeight: 800,
    color: "#1a3a6e",
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  bodyText: {
    fontSize: 14,
    color: "#4a6080",
    lineHeight: 1.85,
    margin: "0 0 10px 0",
  },
  list: {
    margin: "6px 0 10px 0",
    paddingLeft: 22,
  },
  listItem: {
    fontSize: 14,
    color: "#4a6080",
    lineHeight: 1.85,
    marginBottom: 4,
  },
  definitionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
    gap: 10,
    marginTop: 14,
  },
  definitionCard: {
    background: "#f8faff",
    borderRadius: 10,
    padding: "12px 14px",
    border: "1px solid #e3ecf7",
  },
  defTerm: {
    display: "block",
    fontSize: 11,
    fontWeight: 700,
    color: "#1565c0",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: 4,
  },
  defText: {
    fontSize: 13,
    color: "#4a6080",
    lineHeight: 1.6,
    margin: 0,
  },
  /* ── Face Data ── */
  faceDataBox: {
    background: "#f0f7ff",
    border: "1.5px solid #bbdefb",
    borderRadius: 14,
    padding: "22px 24px",
    margin: "14px 0",
  },
  faceDataHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 16,
    paddingBottom: 14,
    borderBottom: "1px solid #bbdefb",
  },
  faceDataTitle: {
    fontSize: 16,
    fontWeight: 800,
    color: "#1a3a6e",
  },
  /* Summary alert strip */
  faceSummaryStrip: {
    background: "#fff3e0",
    border: "1.5px solid #ffcc80",
    borderRadius: 10,
    padding: "14px 16px",
    marginBottom: 18,
  },
  faceSummaryHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 8,
  },
  faceSummaryTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "#e65100",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
  },
  faceSummaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: 8,
  },
  faceSummaryItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    fontSize: 13,
    color: "#bf360c",
    lineHeight: 1.5,
  },
  faceSummaryDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#e65100",
    marginTop: 5,
    flexShrink: 0,
  },
  /* Face data sub-sections */
  faceSubGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: 12,
    marginTop: 12,
  },
  faceSubCard: (borderColor) => ({
    background: "#fff",
    borderRadius: 10,
    padding: "14px 16px",
    border: `1px solid ${borderColor || "#e3ecf7"}`,
  }),
  faceSubCardLabel: (color) => ({
    fontSize: 12,
    fontWeight: 700,
    color: color || "#1565c0",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: 8,
    display: "flex",
    alignItems: "center",
    gap: 6,
  }),
  faceSubCardIcon: {
    fontSize: 14,
  },
  /* Retention highlight */
  retentionHighlight: {
    background: "#e8f5e9",
    border: "1.5px solid #a5d6a7",
    borderRadius: 10,
    padding: "14px 16px",
    marginBottom: 12,
  },
  retentionHighlightTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "#1b5e20",
    marginBottom: 4,
  },
  retentionHighlightText: {
    fontSize: 13,
    color: "#2e7d32",
    lineHeight: 1.6,
    margin: 0,
  },
  retentionWhyBox: {
    background: "#f8faff",
    borderRadius: 10,
    padding: "12px 14px",
    border: "1px solid #e3ecf7",
    marginTop: 10,
  },
  retentionWhyTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: "#1565c0",
    marginBottom: 6,
  },
  retentionAfterBox: {
    background: "#fce4ec",
    border: "1px solid #f48fb1",
    borderRadius: 10,
    padding: "12px 14px",
    marginTop: 10,
  },
  retentionAfterTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: "#880e4f",
    marginBottom: 4,
  },
  /* Firebase clarification */
  firebaseBox: {
    background: "#fff8e1",
    border: "1.5px solid #ffe082",
    borderRadius: 10,
    padding: "14px 16px",
    marginTop: 12,
  },
  firebaseHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 6,
  },
  firebaseName: {
    fontSize: 13,
    fontWeight: 700,
    color: "#e65100",
  },
  /* Cookie table */
  cookieTable: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginTop: 12,
  },
  cookieRow: {
    background: "#f8faff",
    borderRadius: 10,
    padding: "12px 14px",
    border: "1px solid #e3ecf7",
  },
  cookieName: {
    fontSize: 13,
    fontWeight: 700,
    color: "#1a2a4a",
    marginBottom: 4,
  },
  cookieMeta: {
    display: "flex",
    gap: 6,
    marginBottom: 6,
    flexWrap: "wrap",
  },
  cookieTag: {
    fontSize: 11,
    fontWeight: 600,
    background: "#e3f2fd",
    color: "#1565c0",
    borderRadius: 100,
    padding: "2px 10px",
  },
  cookiePurpose: {
    fontSize: 13,
    color: "#4a6080",
    lineHeight: 1.6,
    margin: 0,
  },
  retentionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: 10,
    marginTop: 10,
  },
  retentionCard: {
    background: "#f8faff",
    borderRadius: 10,
    padding: "12px 14px",
    border: "1px solid #e3ecf7",
  },
  retentionLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: "#1a2a4a",
    marginBottom: 4,
  },
  retentionDetail: {
    fontSize: 12,
    color: "#4a6080",
    lineHeight: 1.55,
  },
  thirdPartyCard: {
    background: "#fff8e1",
    border: "1.5px solid #ffe082",
    borderRadius: 12,
    padding: "14px 16px",
    marginTop: 10,
  },
  thirdPartyHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 6,
  },
  thirdPartyName: {
    fontSize: 13,
    fontWeight: 700,
    color: "#e65100",
  },
  ctaBox: {
    background: "linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%)",
    border: "1.5px solid #bbdefb",
    borderRadius: 16,
    padding: "36px 32px",
    textAlign: "center",
  },
  ctaTitle: {
    fontSize: 21,
    fontWeight: 800,
    color: "#1a3a6e",
    marginBottom: 8,
  },
  ctaSub: {
    fontSize: 14,
    color: "#546e8a",
    marginBottom: 8,
    lineHeight: 1.6,
  },
  ctaContact: {
    fontSize: 14,
    color: "#1565c0",
    fontWeight: 600,
  },
  ctaCredit: {
    fontSize: 12,
    color: "#90a4ae",
    marginTop: 18,
    fontStyle: "italic",
  },
  divider: {
    height: 1,
    background: "#e8f0fb",
    margin: "16px 0",
  },
};

function Section({ icon, title, children, last }) {
  return (
    <div style={last ? styles.sectionBlockLast : styles.sectionBlock}>
      <h2 style={styles.sectionTitle}>
        <span>{icon}</span>
        {title}
      </h2>
      {children}
    </div>
  );
}

const infoCards = [
  { icon: "🏢", bg: "#e3f2fd", label: "Company",            value: "BAASHYAAM CONSTRUCTIONS\nPRIVATE LIMITED" },
  { icon: "📍", bg: "#e8f5e9", label: "Registered Address",  value: "NO 87, G N Chetty Road,\nT Nagar, Chennai – 600017" },
  { icon: "✉️", bg: "#fff3e0", label: "Contact Email",       value: "hr@bashyamgroup.com" },
];

export default function PrivacyPolicy() {
  return (
    <>
      <Loginheader />
      <div style={styles.wrapper}>

        {/* ── Hero ── */}
        <div style={styles.hero}>
          <div style={styles.heroDate}>Last updated: March 30, 2026</div>
          <div style={styles.heroBadge}>🔒&nbsp; Privacy &amp; Data Protection</div>
          <h1 style={styles.heroTitle}>Privacy Policy for BEMSS</h1>
          <p style={styles.heroSub}>
            This Privacy Policy describes Our policies and procedures on the collection,
            use and disclosure of Your information when You use the Service and tells You
            about Your privacy rights and how the law protects You.
          </p>
        </div>

        {/* ── Info Cards ── */}
        <p style={styles.sectionLabel}>About the Company</p>
        <div style={styles.infoGrid}>
          {infoCards.map(({ icon, bg, label, value }) => (
            <div key={label} style={styles.infoCard}>
              <div style={styles.cardIcon(bg)}>{icon}</div>
              <div style={styles.cardLabel}>{label}</div>
              <div style={styles.cardValue}>{value}</div>
            </div>
          ))}
        </div>

        {/* ── Policy Content ── */}
        <p style={styles.sectionLabel}>Policy Details</p>
        <div style={styles.policyCard}>

          {/* 1. Interpretation */}
          <Section icon="📖" title="Interpretation and Definitions">
            <p style={styles.bodyText}>
              <strong>Interpretation:</strong> The words whose initial letters are capitalized have
              meanings defined under the following conditions. The following definitions shall have
              the same meaning regardless of whether they appear in singular or in plural.
            </p>
            <div style={styles.definitionGrid}>
              {[
                ["Account",          "A unique account created for You to access our Service or parts of our Service."],
                ["Affiliate",        "An entity that controls, is controlled by, or is under common control with a party, where \"control\" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority."],
                ["Company",          "Refers to BAASHYAAM CONSTRUCTIONS PRIVATE LIMITED, NO 87, G N Chetty Road, T Nagar, Chennai – 600017 (also referred to as \"We\", \"Us\" or \"Our\" in this Policy)."],
                ["Cookies",          "Small files placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses."],
                ["Country",          "Tamil Nadu, India."],
                ["Device",           "Any device that can access the Service such as a computer, a cell phone or a digital tablet."],
                ["Personal Data",    "Any information that relates to an identified or identifiable individual. We use \"Personal Data\" and \"Personal Information\" interchangeably unless a law uses a specific term."],
                ["Service",          "Refers to the Website."],
                ["Service Provider", "Any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service or to assist the Company in analyzing how the Service is used."],
                ["Usage Data",       "Data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (e.g., the duration of a page visit)."],
                ["Website",          "BEMSS, accessible from https://bemss.in/."],
                ["You",              "The individual accessing or using the Service, or the company or other legal entity on behalf of which such individual is accessing or using the Service."],
              ].map(([term, def]) => (
                <div key={term} style={styles.definitionCard}>
                  <span style={styles.defTerm}>{term}</span>
                  <p style={styles.defText}>{def}</p>
                </div>
              ))}
            </div>
          </Section>

          {/* 2. Types of Data Collected */}
          <Section icon="🗂️" title="Types of Data Collected">
            <p style={styles.bodyText}>
              <strong>Personal Data:</strong> While using Our Service, We may ask You to provide Us
              with certain personally identifiable information that can be used to contact or identify
              You. Personally identifiable information may include, but is not limited to:
            </p>
            <ul style={styles.list}>
              {["Email address", "First name and last name", "Phone number", "Address, State, Province, ZIP/Postal code, City"]
                .map(i => <li key={i} style={styles.listItem}>{i}</li>)}
            </ul>

            {/* ── Expanded Face Data Block ── */}
            <div style={styles.faceDataBox}>
              {/* Header */}
              <div style={styles.faceDataHeader}>
                <span style={{ fontSize: 20 }}>📷</span>
                <span style={styles.faceDataTitle}>Face Data Collection and Usage</span>
              </div>

              {/* 🔴 Summary Strip */}
              <div style={styles.faceSummaryStrip}>
                <div style={styles.faceSummaryHeader}>
                  <span style={{ fontSize: 14 }}>🔴</span>
                  <span style={styles.faceSummaryTitle}>Face Data Summary</span>
                </div>
                <div style={styles.faceSummaryGrid}>
                  {[
                    "Face data is NOT retained indefinitely",
                    "Face data is stored securely for a maximum of 30 days only",
                    "Face data is NOT shared with any third parties",
                    "No third-party services store or process face data",
                  ].map((item, i) => (
                    <div key={i} style={styles.faceSummaryItem}>
                      <div style={styles.faceSummaryDot} />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Sub-section cards row 1 */}
              <div style={styles.faceSubGrid}>
                {/* What we collect */}
                <div style={styles.faceSubCard("#e3ecf7")}>
                  <div style={styles.faceSubCardLabel("#1565c0")}>
                    <span style={styles.faceSubCardIcon}>📌</span>
                    What Face Data We Collect
                  </div>
                  <p style={{ ...styles.bodyText, marginBottom: 6 }}>We collect:</p>
                  <ul style={{ ...styles.list, marginTop: 0 }}>
                    <li style={styles.listItem}>Facial images captured during employee check-in and check-out using the device camera.</li>
                    <li style={styles.listItem}>Face recognition data generated from these images for identity verification.</li>
                  </ul>
                </div>

                {/* Purpose */}
                <div style={styles.faceSubCard("#e3ecf7")}>
                  <div style={styles.faceSubCardLabel("#1565c0")}>
                    <span style={styles.faceSubCardIcon}>🎯</span>
                    Purpose of Face Data
                  </div>
                  <p style={{ ...styles.bodyText, marginBottom: 6 }}>Face data is used strictly for:</p>
                  <ul style={{ ...styles.list, marginTop: 0 }}>
                    <li style={styles.listItem}>Employee attendance verification</li>
                    <li style={styles.listItem}>Preventing proxy attendance</li>
                    <li style={styles.listItem}>Ensuring correct employee identity</li>
                  </ul>
                </div>
              </div>

              <div style={styles.divider} />

              {/* ⏳ Retention */}
              <div style={styles.faceSubCardLabel("#1a3a6e")}>
                <span style={styles.faceSubCardIcon}>⏳</span>
                Face Data Retention
              </div>

              <div style={styles.retentionHighlight}>
                <div style={styles.retentionHighlightTitle}>Maximum retention period: 30 days</div>
                <p style={styles.retentionHighlightText}>
                  Face data is retained for a maximum of 30 days from the date of collection and is not retained indefinitely.
                </p>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <div style={styles.retentionWhyBox}>
                  <div style={styles.retentionWhyTitle}>Why 30 days?</div>
                  <ul style={{ ...styles.list, marginTop: 0 }}>
                    <li style={{ ...styles.listItem, fontSize: 13 }}>To verify attendance records</li>
                    <li style={{ ...styles.listItem, fontSize: 13 }}>To resolve disputes or audit requests</li>
                    <li style={{ ...styles.listItem, fontSize: 13 }}>To ensure system accuracy and prevent misuse</li>
                  </ul>
                </div>
                <div style={styles.retentionAfterBox}>
                  <div style={styles.retentionAfterTitle}>After 30 days:</div>
                  <p style={{ fontSize: 13, color: "#880e4f", lineHeight: 1.6, margin: 0 }}>
                    Face data is automatically and permanently deleted from our systems.
                  </p>
                </div>
              </div>

              <div style={styles.divider} />

              {/* Sharing + Third-party row */}
              <div style={styles.faceSubGrid}>
                {/* Face Data Sharing */}
                <div style={{ ...styles.faceSubCard("#fce4ec"), borderColor: "#f48fb1" }}>
                  <div style={styles.faceSubCardLabel("#c62828")}>
                    <span style={styles.faceSubCardIcon}>📤</span>
                    Face Data Sharing
                  </div>
                  <ul style={{ ...styles.list, marginTop: 0 }}>
                    <li style={styles.listItem}>We do <strong>NOT</strong> share face data with any third parties</li>
                    <li style={styles.listItem}>We do <strong>NOT</strong> sell, rent, or transfer face data</li>
                    <li style={styles.listItem}>Face data is used only within our internal system</li>
                  </ul>
                </div>

                {/* Third-Party Access */}
                <div style={{ ...styles.faceSubCard("#fce4ec"), borderColor: "#f48fb1" }}>
                  <div style={styles.faceSubCardLabel("#c62828")}>
                    <span style={styles.faceSubCardIcon}>🧾</span>
                    Third-Party Access
                  </div>
                  <ul style={{ ...styles.list, marginTop: 0 }}>
                    <li style={styles.listItem}>We do <strong>NOT</strong> share face data with any third-party services</li>
                    <li style={styles.listItem}>No third-party providers store or process face data</li>
                  </ul>
                </div>
              </div>

              {/* Firebase Clarification */}
              <div style={styles.firebaseBox}>
                <div style={styles.firebaseHeader}>
                  <span style={{ fontSize: 16 }}>🔥</span>
                  <span style={styles.firebaseName}>Firebase Clarification</span>
                </div>
                <ul style={{ ...styles.list, marginTop: 0 }}>
                  <li style={styles.listItem}>Firebase is used <strong>only for push notifications</strong></li>
                  <li style={styles.listItem}>Firebase may process device-related data (such as device tokens) to deliver notifications</li>
                  <li style={styles.listItem}>Firebase does <strong>NOT</strong> collect, process, or store face data</li>
                </ul>
              </div>
            </div>
            {/* ── End Face Data Block ── */}

            <p style={{ ...styles.bodyText, marginTop: 14 }}>
              <strong>Usage Data</strong> is collected automatically when using the Service and may
              include information such as Your Device's IP address, browser type, browser version,
              the pages of our Service that You visit, the time and date of Your visit, the time
              spent on those pages, unique device identifiers and other diagnostic data.
            </p>
            <p style={styles.bodyText}>
              When You access the Service through a mobile device, We may additionally collect the
              type of mobile device You use, Your mobile device's unique ID, Your mobile operating
              system, the type of mobile Internet browser You use, unique device identifiers and
              other diagnostic data.
            </p>
          </Section>

          {/* 3. Cookies */}
          <Section icon="🍪" title="Tracking Technologies and Cookies">
            <p style={styles.bodyText}>
              We use Cookies and similar tracking technologies to track the activity on Our Service
              and store certain information. Technologies We use may include:
            </p>
            <ul style={styles.list}>
              <li style={styles.listItem}><strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service.</li>
              <li style={styles.listItem}><strong>Web Beacons.</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company to count users who have visited those pages or opened an email.</li>
            </ul>
            <p style={styles.bodyText}>
              Where required by law, we use non-essential cookies only with Your consent. You can
              withdraw or change Your consent at any time through Your browser/device settings.
              Withdrawing consent does not affect the lawfulness of processing based on consent
              before its withdrawal.
            </p>
            <div style={styles.cookieTable}>
              {[
                { type: "Necessary / Essential Cookies",              kind: "Session Cookies",    purpose: "Essential to provide You with services available through the Website and to enable You to use some of its features. They help authenticate users and prevent fraudulent use of user accounts." },
                { type: "Cookies Policy / Notice Acceptance Cookies", kind: "Persistent Cookies", purpose: "Identify if users have accepted the use of cookies on the Website." },
                { type: "Functionality Cookies",                      kind: "Persistent Cookies", purpose: "Allow Us to remember choices You make when You use the Website, such as remembering your login details or language preference." },
              ].map((row) => (
                <div key={row.type} style={styles.cookieRow}>
                  <div style={styles.cookieName}>{row.type}</div>
                  <div style={styles.cookieMeta}>
                    <span style={styles.cookieTag}>{row.kind}</span>
                    <span style={styles.cookieTag}>Administered by: Us</span>
                  </div>
                  <p style={styles.cookiePurpose}>{row.purpose}</p>
                </div>
              ))}
            </div>
          </Section>

          {/* 4. Use of Personal Data */}
          <Section icon="⚙️" title="Use of Your Personal Data">
            <p style={styles.bodyText}>The Company may use Personal Data for the following purposes:</p>
            <ul style={styles.list}>
              {[
                "To provide and maintain our Service, including to monitor the usage of our Service.",
                "To manage Your Account: to manage Your registration as a user of the Service.",
                "For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.",
                "To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication regarding updates or security updates.",
                "To provide You with news, special offers, and general information about other goods, services and events which We offer.",
                "To manage Your requests: To attend and manage Your requests to Us.",
                "For business transfers: to evaluate or conduct a merger, divestiture, restructuring, or other sale or transfer of some or all of Our assets.",
                "For other purposes: data analysis, identifying usage trends, evaluating and improving Our Service, products, services, marketing and your experience.",
              ].map((p, i) => <li key={i} style={styles.listItem}>{p}</li>)}
            </ul>
            <p style={{ ...styles.bodyText, marginTop: 12 }}><strong>We may share Your Personal Data in the following situations:</strong></p>
            <ul style={styles.list}>
              {[
                "With Service Providers: to monitor and analyze the use of our Service, to contact You.",
                "For business transfers: in connection with any merger, sale of Company assets, financing, or acquisition.",
                "With Affiliates: who are required to honor this Privacy Policy.",
                "With business partners: to offer You certain products, services or promotions.",
                "With other users: when You share Personal Data or otherwise interact in any public areas offered by the Service.",
                "With Your consent: We may disclose Your Personal Data for any other purpose with Your consent.",
              ].map((p, i) => <li key={i} style={styles.listItem}>{p}</li>)}
            </ul>
          </Section>

          {/* 5. Retention */}
          <Section icon="🗄️" title="Retention of Your Personal Data">
            <p style={styles.bodyText}>
              The Company will retain Your Personal Data only for as long as is necessary for the
              purposes set out in this Privacy Policy. Where possible, We apply shorter retention
              periods and/or reduce identifiability by deleting, aggregating, or anonymizing data.
            </p>
            <div style={styles.retentionGrid}>
              {[
                { label: "User Accounts",                                  detail: "Duration of account relationship + up to 24 months after closure." },
                { label: "Support Tickets & Correspondence",               detail: "Up to 24 months from ticket closure." },
                { label: "Chat Transcripts",                               detail: "Up to 24 months for quality assurance and staff training." },
                { label: "Website Analytics (cookies, IPs, device IDs)",   detail: "Up to 24 months from date of collection." },
                { label: "Server Logs (IP addresses, access times)",        detail: "Up to 24 months for security monitoring and troubleshooting." },
              ].map(({ label, detail }) => (
                <div key={label} style={styles.retentionCard}>
                  <div style={styles.retentionLabel}>{label}</div>
                  <div style={styles.retentionDetail}>{detail}</div>
                </div>
              ))}
            </div>
            <p style={{ ...styles.bodyText, marginTop: 14 }}>
              We may retain Personal Data beyond the periods stated above for legal obligations,
              established legal claims, Your explicit request, or technical backup limitations.
              When retention periods expire, We securely delete or anonymize Personal Data.
            </p>
          </Section>

          {/* 6. Transfer */}
          <Section icon="🌐" title="Transfer of Your Personal Data">
            <p style={styles.bodyText}>
              Your information, including Personal Data, is processed at the Company's operating
              offices and in any other places where the parties involved in the processing are
              located. This information may be transferred to — and maintained on — computers
              located outside of Your state, province, country or other governmental jurisdiction
              where the data protection laws may differ from those of Your jurisdiction. Where
              required by applicable law, We will ensure that international transfers of Your
              Personal Data are subject to appropriate safeguards. No transfer of Your Personal
              Data will take place to an organization or a country unless there are adequate
              controls in place including the security of Your data and other personal information.
            </p>
          </Section>

          {/* 7. Delete */}
          <Section icon="🗑️" title="Delete Your Personal Data">
            <p style={styles.bodyText}>
              You have the right to delete or request that We assist in deleting the Personal Data
              that We have collected about You. You may update, amend, or delete Your information
              at any time by signing in to Your Account and visiting the account settings section,
              or by contacting Us directly. Please note that We may need to retain certain
              information when We have a legal obligation or lawful basis to do so.
            </p>
          </Section>

          {/* 8. Disclosure */}
          <Section icon="⚖️" title="Disclosure of Your Personal Data">
            <p style={styles.bodyText}><strong>Business Transactions:</strong> If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</p>
            <p style={styles.bodyText}><strong>Law Enforcement:</strong> Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p>
            <p style={styles.bodyText}><strong>Other legal requirements:</strong> The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p>
            <ul style={styles.list}>
              {[
                "Comply with a legal obligation",
                "Protect and defend the rights or property of the Company",
                "Prevent or investigate possible wrongdoing in connection with the Service",
                "Protect the personal safety of Users of the Service or the public",
                "Protect against legal liability",
              ].map((p, i) => <li key={i} style={styles.listItem}>{p}</li>)}
            </ul>
          </Section>

          {/* 9. Security */}
          <Section icon="🔒" title="Security of Your Personal Data">
            <p style={styles.bodyText}>
              The security of Your Personal Data is important to Us, but remember that no method of
              transmission over the Internet, or method of electronic storage is 100% secure. While
              We strive to use commercially reasonable means to protect Your Personal Data, We
              cannot guarantee its absolute security.
            </p>
          </Section>

          {/* 10. Children's Privacy */}
          <Section icon="👶" title="Children's Privacy">
            <p style={styles.bodyText}>
              Our Service does not address anyone under the age of 16. We do not knowingly collect
              personally identifiable information from anyone under the age of 16. If You are a
              parent or guardian and You are aware that Your child has provided Us with Personal
              Data, please contact Us. If We become aware that We have collected Personal Data from
              anyone under the age of 16 without verification of parental consent, We take steps to
              remove that information from Our servers.
            </p>
            <p style={styles.bodyText}>
              If We need to rely on consent as a legal basis for processing Your information and
              Your country requires consent from a parent, We may require Your parent's consent
              before We collect and use that information.
            </p>
          </Section>

          {/* 11. Third-Party Services */}
          <Section icon="🔌" title="Third-Party Services">
            <p style={styles.bodyText}>
              We use limited third-party services strictly for essential functionality.{" "}
              <strong>We do not sell or share Personal Data or face data with third parties.</strong>
            </p>
            <div style={styles.thirdPartyCard}>
              <div style={styles.thirdPartyHeader}>
                <span style={{ fontSize: 18 }}>🔥</span>
                <span style={styles.thirdPartyName}>Firebase (Push Notifications)</span>
              </div>
              <ul style={{ ...styles.list, marginTop: 4 }}>
                <li style={styles.listItem}>Firebase may process device-related data (such as device tokens) to deliver notifications.</li>
                <li style={styles.listItem}>We do not share Personal Data or face data with Firebase for marketing, analytics, or profiling.</li>
                <li style={styles.listItem}>Firebase is used only for operational communication purposes.</li>
              </ul>
            </div>
          </Section>

          {/* 12. Changes */}
          <Section icon="🔄" title="Changes to this Privacy Policy" last>
            <p style={styles.bodyText}>
              We may update Our Privacy Policy from time to time. We will notify You of any changes
              by posting the new Privacy Policy on this page. We will let You know via email and/or
              a prominent notice on Our Service, prior to the change becoming effective and update
              the "Last updated" date at the top of this Privacy Policy. You are advised to review
              this Privacy Policy periodically for any changes. Changes to this Privacy Policy are
              effective when they are posted on this page.
            </p>
          </Section>

        </div>

        {/* ── CTA Contact ── */}
        <div style={styles.ctaBox}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>📬</div>
          <h2 style={styles.ctaTitle}>Have Questions About Your Privacy?</h2>
          <p style={styles.ctaSub}>
            If you have any questions about this Privacy Policy or how We handle your
            Personal Data, feel free to reach out to us directly.
          </p>
          <p style={styles.ctaContact}>
            ✉️&nbsp;{" "}
            <a href="mailto:hr@bashyamgroup.com" style={{ color: "#1565c0", textDecoration: "none" }}>
              hr@bashyamgroup.com
            </a>
          </p>
          <p style={styles.ctaCredit}>Generated by Baashyam Software Developers</p>
        </div>

      </div>
      <Footer />
    </>
  );
}